import React from "react";

const Footer = () => {
  return (
<footer className="w-full text-gray-700 border-t-[1px] border-[#023437]">
      {/* Top Section */}
      <div className="bg-gray-50 px-6 sm:px-10 lg:px-20 py-12 flex flex-col lg:flex-row justify-between gap-12">
        {/* Left - Links & Logo */}
        <div className="flex-1">
          {/* Logo */}
          <div className="flex items-center gap-2 mb-6">
            <div className="w-10 h-10 bg-[#023437] rounded-full flex items-center justify-center text-white font-bold">
              BI
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-800">Birth Injury</h2>
              <p className="italic text-sm text-[#023437]">Justice Center</p>
            </div>
          </div>

          {/* Quick Links */}
          <h3 className="font-semibold text-lg mb-4 text-gray-800">
            Quick Links
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 gap-3">
            <a href="#" className="hover:text-[#023437] transition">
              Birth Injuries
            </a>
            <a href="#" className="hover:text-[#023437] transition">
              Cerebral Palsy
            </a>
            <a href="#" className="hover:text-[#023437] transition">
              Erb’s Palsy
            </a>
            <a href="#" className="hover:text-[#023437] transition">
              Legal Help
            </a>
            <a href="#" className="hover:text-[#023437] transition">
              About Us
            </a>
            <a href="#" className="hover:text-[#023437] transition">
              Contact Us
            </a>
          </div>

          {/* Disclaimer */}
          <p className="text-xs mt-6 leading-relaxed text-gray-600">
            © 2025 child birth injury — The information provided by
            childbirthinjuries.com is not a substitute for legal or professional
            medical advice. If you request any information you may receive a
            phone call or email from a partner law firm. If you call our legal
            help phone number, you will be connected to a partner law firm to
            discuss your inquiry.
          </p>
        </div>

        {/* Right - Newsletter */}
        <div className="flex-1">
          <h3 className="font-semibold text-lg mb-3 text-gray-800">
            Subscribe to Our Newsletter
          </h3>
          <p className="text-sm mb-6 text-gray-600">
            Get the latest on birth injury symptoms, legal options, and support
            resources — delivered to your inbox.
          </p>

          <form className="flex flex-col gap-4">
            {/* First/Last Name */}
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="text"
                placeholder="First Name*"
                className="flex-1 px-3 py-2 rounded-md bg-white border border-gray-300 outline-none focus:border-[#023437]"
              />
              <input
                type="text"
                placeholder="Last Name*"
                className="flex-1 px-3 py-2 rounded-md bg-white border border-gray-300 outline-none focus:border-[#023437]"
              />
            </div>

            {/* Email + Button */}
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder="Your Email*"
                className="flex-1 px-3 py-2 rounded-md bg-white border border-gray-300 outline-none focus:border-[#023437]"
              />
              <button
                type="submit"
                className="bg-[#023437] text-white px-6 py-2 rounded-md font-semibold hover:bg-teal-900 transition"
              >
                Subscribe
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="bg-[#023437] text-gray-50 text-center px-4 py-4 text-sm">
        <p className="leading-relaxed">
          © 2025 child birth injury — Use of this website is subject to our{" "}
          <a href="#" className="underline hover:text-teal-100">
            privacy policy
          </a>
          ,{" "}
          <a href="#" className="underline hover:text-teal-100">
            terms of use
          </a>
          ,{" "}
          <a href="#" className="underline hover:text-teal-100">
            cookie policy
          </a>{" "}
          and{" "}
          <a href="#" className="underline hover:text-teal-100">
            disclaimer
          </a>
          .
        </p>
      </div>
    </footer>
  );
};

export default Footer;
